import { combineReducers } from 'redux';
import generalReducer from './general';
import toursReducer from './tours';
import userReducer from './user';

const combinedReducer = combineReducers({
  general: generalReducer,
  tours: toursReducer,
  user: userReducer
});

// Ending or switching a session discards company data, open overlays and user-specific tour state.
export default (state, action) => combinedReducer(action.type === 'CLEAR_USER' || action.type === 'SWITCH_USER' ? undefined : state, action);
